import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { cn } from 'src/@/lib/utils';

// ----------------------------------------------------------------------

DrawerNegocioStagesPipeline.propTypes = {
    disabled: PropTypes.bool,
    conversationId: PropTypes.string,
    onSend: PropTypes.func,
    activeStepProps: PropTypes.number,
    estagios: PropTypes.array,
    onChange: PropTypes.func,
};

export default function DrawerNegocioStagesPipeline({
    disabled,
    activeStepProps,
    estagios,
    onChange,
    ...other
}) {
    const [activeStep, setActiveStep] = React.useState(activeStepProps || 0);

    useEffect(() => {
        setActiveStep(activeStepProps || 0);
    }, [activeStepProps]);

    const handleStageClick = (stage, index) => {
        if (onChange) {
            onChange(stage._id);
        }
        setActiveStep(index);
    };

    if (!estagios?.length) return null;

    return (
        <div
            className="relative w-full min-w-full h-auto overflow-x-auto scrollbar-hide"
            {...other}
        >
            <div className="flex items-center w-full h-[40px]">
                {estagios.map((stage, index) => {
                    const isReached = index <= activeStep;
                    const isFirst = index === 0;
                    const isLast = index === estagios.length - 1;
                    const isClickable = !disabled && onChange;

                    return (
                        <div
                            key={stage._id}
                            className={cn(
                                "relative flex items-center flex-1",
                                isClickable && "cursor-pointer"
                            )}
                            onClick={() => isClickable && handleStageClick(stage, index)}
                        >
                            <div
                                className={cn(
                                    "relative h-8 w-full flex items-center justify-center text-pink-900 dark:text-pink-100 px-2 py-2 transition-all duration-200",
                                    isReached
                                        ? "bg-pink-500 hover:bg-pink-600 text-white"
                                        : "bg-slate-300 dark:bg-[#383838] hover:bg-gray-200 dark:hover:bg-[#4a4a4a]",
                                    !isLast && "mr-[-1px]"
                                )}
                                style={{
                                    clipPath: isFirst
                                        ? 'polygon(0 0, calc(100% - 8px) 0, 100% 50%, calc(100% - 8px) 100%, 0 100%, 0 0)'
                                        : isLast
                                            ? 'polygon(8px 50%, 0 0, 100% 0, 100% 100%, 0 100%, 8px 50%)'
                                            : 'polygon(0 0, calc(100% - 8px) 0, 100% 50%, calc(100% - 8px) 100%, 0 100%, 8px 50%)',
                                    zIndex: estagios.length - index
                                }}
                            >
                                <span className="text-center whitespace-nowrap overflow-hidden text-ellipsis text-xs">
                                    {stage.nome}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
